import Navbar from '../Navbar/Navbar.jsx';
import PromoBar from '../PromoBar/PromoBar.jsx';
import {Footer} from '../Footer/Footer.jsx';
const Layout = ({ children }) => (
  <>
    <nav className=" w-full fixed top-0 left-0 z-50">
      <div className="">
        <PromoBar />
      </div>

      <div className="">
        <Navbar />
      </div>
    </nav>

    <main className="mt-44 md:mt-40">
      {children}
    </main>

    <footer>
      <Footer />
    </footer>
  </>
);

export default Layout;
